import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";

export default function ProtectedRoute({ children }) {
  const { user, initializing } = useAuth();

  if (initializing || user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-bone">
        <div className="text-muted-warm font-display text-xl">Loading...</div>
      </div>
    );
  }

  if (!user) return <Navigate to="/admin/login" replace />;
  return children;
}
